import type { TripHandoverView } from '@chukua/common';
import { RowListSkeleton } from '../../../shared/components/RowListSkeleton';
import type { HandoversState } from '../hooks/use-handover-trip';

const when = (iso: string) => new Date(iso).toLocaleString('en-KE', { dateStyle: 'medium', timeStyle: 'short' });

function HandoverRow({ handover }: { handover: TripHandoverView }) {
  return (
    <li className="rounded-lg border border-line px-4 py-3 text-sm">
      <p className="font-medium text-fg">
        {handover.from.name} to {handover.to.name}
      </p>
      <p className="text-muted">
        {when(handover.handedOverAt)}
        {handover.handedOverBy ? ` by ${handover.handedOverBy.name}` : ''}
        {' · '}
        {handover.acknowledgedAt ? `Accepted ${when(handover.acknowledgedAt)}` : 'Not yet accepted on the phone'}
      </p>
      <p className="mt-1 text-fg">{handover.reason}</p>
    </li>
  );
}

/** Oldest first, so the last row is who holds the trip now. */
export function HandoverHistory({ state }: { state: HandoversState }) {
  if (state.status === 'loading') return <RowListSkeleton label="Loading handovers" rows={1} />;
  if (state.status === 'error') return <p className="text-sm text-muted">Couldn&apos;t load the handover history. Try reloading the page.</p>;
  if (state.handovers.length === 0) return <p className="text-sm text-muted">This trip has had one driver so far.</p>;
  return (
    <ol className="flex flex-col gap-2">
      {state.handovers.map((handover) => (
        <HandoverRow key={handover.id} handover={handover} />
      ))}
    </ol>
  );
}
